<template>
  <footer class="footer">
    <div class="container padding-1">
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-xs">
              <a href="https://digital.swisscom.com/imprint" target="_blank" class="nav-link margin-left-1 margin-right-1"> Imprint </a>
              <span> | </span>
              <a href="https://digital.swisscom.com/terms" target="_blank" class="nav-link margin-left-1 margin-right-1"> Terms </a>
            </div>
            <div class="col-xs col-md-auto">
              <span class="margin-left-1 margin-right-1">Version {{ version }}</span>
              <span> | </span>
              <a href="https://www.swisscom.ch/en/about/company.html" target="_blank" class="nav-link margin-left-1 margin-right-1">
                © Swisscom AG {{ new Date().getFullYear() }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {logger} from "@/services/logger.service";

export default {
  data() {
    return {
      version: 0,
    };
  },
  created() {
    this.version = process.env.PACKAGE_VERSION || '0'
    logger.debug("version: " + this.version)
  },
};
</script>

<style>

</style>
